import React from 'react'

export default function PassageBreakdowns ({data}) {
  let cols = []
  data.forEach((passageType, n) => {
    const perc = Math.round(passageType.percent * 100)
    cols.push(
      <div className={`col col-${n + 1}`} key={`${passageType.name}${n}`}>
        <div className='skill-item sub-skill'>
          <h6 className='title'>{passageType.name}</h6>
          <div className='bar-graph'>
            <span className='score-percent'>{`${perc}%`}</span>
            <div className='score-graph-container'>
              <span className='score-graph' style={{width: `${perc}%`}}></span>
            </div>
          </div>
        </div>
      </div>  
    )
  })


  return (
    <section className='passage-breakdowns'>
      <div className='passage-category'>
        <div className='passage-item'>
          <h6 className='title'>Type of Passage</h6>
        </div>
      </div>
      {cols}
    </section>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/PassageBreakdowns.js